import { render, staticRenderFns } from "./edit-contact-modal.vue?vue&type=template&id=397d6f03&lang=pug"
import script from "./edit-contact-modal.vue?vue&type=script&lang=js"
export * from "./edit-contact-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports